import {
  alignMaskToImage,
  prepareImageForAi,
} from "../../../utils/prepareImageForAi";

/** Append a downscaled copy. Returns the file that was appended. */
export async function appendPreparedImage(form, field, file) {
  const prepared = await prepareImageForAi(file);
  form.append(field, prepared, prepared.name || "image.jpg");
  return prepared;
}

/**
 * Append image_url or a downscaled file. Returns the prepared file, or null
 * when the request uses a URL (the server fits that image).
 */
export async function appendAiImage(
  form,
  file,
  { imageUrl, field = "file", requiredMessage } = {}
) {
  const urlOpt = imageUrl && String(imageUrl).trim();
  if (urlOpt) {
    form.append("image_url", urlOpt);
    return null;
  }
  if (file) return appendPreparedImage(form, field, file);
  throw new Error(requiredMessage || "Provide a file or image_url");
}

/** Resize a mask onto the prepared image. URL-only requests keep the mask. */
export async function appendPreparedMask(form, mask, referenceImage) {
  if (!mask) return;
  const aligned = referenceImage ? await alignMaskToImage(mask, referenceImage) : mask;
  form.append("mask", aligned, aligned.name || "mask.png");
}
